<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>
      <b-col cols="12" md="6" v-if="props.mode === 'Personal'">
        <b-form-group label="ชื่อเจ้าหน้าที่ผู้รับเรื่อง" label-for="officer">
          <vue-select
            label="text"
            v-model="officer"
            :options="officers"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[3]" />
      </b-col>

      <b-col
        cols="12"
        md="6"
        v-if="
          props.mode !== 'Personal' &&
            currentUserRole === adminRoleId &&
            props.mode !== 'ScreeningSend' &&
            props.mode !== 'ScreeningReceived'
        "
      >
        <b-form-group label="ประเภทหน่วยงานต้นทาง" label-for="depType">
          <vue-select
            label="text"
            v-model="depTypeFrom"
            :options="depTypesFrom"
            @input="selectDepTypeOnInput(1)"
          />
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="6"
        v-if="
          props.mode !== 'Personal' &&
            currentUserRole === adminRoleId &&
            props.mode !== 'ScreeningSend' &&
            props.mode !== 'ScreeningReceived'
        "
      >
        <b-form-group label="หน่วยงานต้นทาง" label-for="department">
          <vue-select
            label="text"
            v-model="departmentFrom"
            :options="departmentsFrom"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6" v-if="props.mode !== 'Personal'">
        <b-form-group label="ประเภทหน่วยงาน" label-for="depType">
          <vue-select
            label="text"
            v-model="depType"
            :options="depTypes"
            @input="selectDepTypeOnInput(0)"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6" v-if="props.mode !== 'Personal'">
        <b-form-group
          label="หน่วยงาน"
          label-for="department"
          description="หมายเหตุ: กรุณาเลือกประเภทหน่วยงานก่อน"
        >
          <vue-select
            label="text"
            v-model="department"
            :options="departments"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
      <!-- TEST SELECT -->
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import InputFilter from "../../../filters/components/InputFilter.vue";

import * as storeMaster from "@/store/api/master/index.js";
import * as departmentStore from "@/store/api/department/index.js";
import appsettings from "@/store/app-settings";
import * as userData from "@/auth/localStorageUtils.js";
import VueSelect from "vue-select";

import * as apiDepartmentRole from "@/store/api/role/departmentRole.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    InputFilter,
    VueSelect,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const depTypes = [
      { text: "ประเภทหน่วยงาน", value: "" },
      { text: "หน่วยงานภายใน", value: "1" },
      { text: "หน่วยงานภายนอก", value: "2" },
    ];

    const depTypesFrom = [
      { text: "ประเภทหน่วยงาน", value: "" },
      { text: "หน่วยงานภายใน", value: "1" },
      { text: "หน่วยงานภายนอก", value: "2" },
    ];

    const departments = [];
    const departmentsFrom = [];
    const officers = [{ text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: "" }];
    const searchList = [
      {
        id: "startdateSearch",
        label: props.label !== "" ? props.label : "ช่วงวันรายการ",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "receiveCodeStart",
        label: "เลขรับแจ้ง",
        value: "",
        class: "",
        style: "",
        placeholder: "ตัวอย่างการกรอกเลขรับแจ้ง OCPBXXXX/XXXXX",
        type: "text",
        options: [],
      },
      {
        id: "receiveCodeEnd",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ตัวอย่างการกรอกเลขรับแจ้ง OCPBXXXX/XXXXX",
        type: "text",
        options: [],
      },
      {
        id: "depType",
        label: "ประเภทหน่วยงาน",
        value: "",
        class: "",
        style: "",
        placeholder: "ประเภทหน่วยงาน",
        type: "bselect",
        options: depTypes,
      },
      {
        id: "department",
        label: "หน่วยงาน",
        value: "",
        class: "",
        style: "",
        placeholder: "หน่วยงาน",
        type: "bselect",
        options: departments,
      },
      {
        id: "depTypeFrom",
        label: "ประเภทหน่วยงานต้นทาง",
        value: "",
        class: "",
        style: "",
        placeholder: "ประเภทหน่วยงาน",
        type: "bselect",
        options: depTypes,
      },
      {
        id: "departmentFrom",
        label: "หน่วยงานต้นทาง",
        value: "",
        class: "",
        style: "",
        placeholder: "หน่วยงาน",
        type: "bselect",
        options: departments,
      },
    ];

    return {
      search: searchList,
      props,
      depTypes,
      departments,
      depType: { text: "ประเภทหน่วยงาน", value: "0" },
      department: null,
      depTypesFrom,
      departmentsFrom,
      depTypeFrom: { text: "ประเภทหน่วยงาน", value: "0" },
      departmentFrom: null,
      officers,
      officer: { text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: "" },
      currentUserRole: userData.selectedRole(),
      adminRoleId: appsettings.complaintRoleId.admin,
      departmentForAdmin: [],
    };
  },
  mounted() {
    if (this.props.mode === "Personal") {
      console.log("Personal Mode");
      this.depType = { value: "1", text: "หน่วยงานภายใน" };
    }
    this.getDepartment();
    this.getOfficer();
    this.getDepartmentNameForAdmin();
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
      this.search[3].value = null;
      this.search[4].value = null;
    },
    onSearchBtnClicked() {
      const _this = this;
      console.log("props.mode", this.props.mode);

      let url = appsettings.complaintSummaryReport;

      if (
        // รายงานรับ|รายงานส่ง ของกอง
        this.props.mode === "DepartmentSend" ||
        this.props.mode === "DepartmentReceived"
      ) {
        let divisionKeygen = "44CC65E0-DF4E-4BA7-961C-EAC435361D6C"; // ระบบรับเรื่องราวร้องทุกข์ (ศูนย์รับเรื่องร้องทุกข์ผู้บริโภค)
        // ผู้ดูแลระบบ
        if (userData.selectedRole() == appsettings.complaintRoleId.admin) {
          //console.log("role is admin", userData.selectedRole());
          divisionKeygen =
            this.departmentFrom !== null ? this.departmentFrom.value : "";
          let divisionName =
            this.departmentFrom !== null ? this.departmentFrom.text : "";

          const params = {
            dateStart: this.search[0].value,
            dateEnd: this.search[1].value,
            receiveCodeStart: this.search[2].value,
            receiveCodeEnd: this.search[3].value,
            divisionType: this.depType !== null ? this.depType.value : null,
            divisionKeygen:
              this.department !== null ? this.department.value : "",
            currentUserName: userData.fullName(),
            ReportMenuType: 1,
            ReportType: this.props.mode === "DepartmentSend" ? 0 : 1,
            currentDivisionKeygen: divisionKeygen,
            currentDivisionName: divisionName,
          };

          url = url + "?" + new URLSearchParams(params).toString();
          console.log("@params-1", params);
          this.$emit("handleSubmit", url);
        }
        // อื่น ๆ ที่ไม่ใช่ เจ้าหน้าที่ศูนย์รับเรื่องราวร้องทุกข์
        else if (
          userData.selectedRole() != "cd9c65ce-31f3-4638-b4c9-041573d77067" // เจ้าหน้าที่ศูนย์รับเรื่องราวร้องทุกข์
        ) {
          //console.log("role not center", userData.selectedRole());
          let divisionKeygen = "";
          divisionKeygen = userData.departmentId();

          // เช็คว่าเป็น admin หรือไม่
          // เนื่องจากกรณีที่เป็น admin ชื่อหน่วยงานที่แสดงบน header ของรายงาน ไม่ตรงกับ dropdown กองที่เลือก
          if (userData.isAdminRole()) {
            const selectedDropdown = userData.selectedAdminDepartment();
            console.log("@params-dropdown-2", selectedDropdown);
            if (
              selectedDropdown !== undefined &&
              selectedDropdown !== null &&
              selectedDropdown !== ""
            ) {
              departmentStore.getById(selectedDropdown).then((response) => {
                console.log("@params-response-2", response);
                const params = {
                  dateStart: this.search[0].value,
                  dateEnd: this.search[1].value,
                  receiveCodeStart: this.search[2].value,
                  receiveCodeEnd: this.search[3].value,
                  divisionType:
                    this.depType !== null ? this.depType.value : null,
                  divisionKeygen:
                    this.department !== null ? this.department.value : "",
                  currentUserName: userData.fullName(),
                  ReportMenuType: 1,
                  ReportType: this.props.mode === "DepartmentSend" ? 0 : 1,
                  currentDivisionKeygen: divisionKeygen,
                  currentDivisionName: response.data.data.name,
                };

                url = url + "?" + new URLSearchParams(params).toString();
                console.log("@params-2", params);
                this.$emit("handleSubmit", url);
              });
            }
          } else {
            const params = {
              dateStart: this.search[0].value,
              dateEnd: this.search[1].value,
              receiveCodeStart: this.search[2].value,
              receiveCodeEnd: this.search[3].value,
              divisionType: this.depType !== null ? this.depType.value : null,
              divisionKeygen:
                this.department !== null ? this.department.value : "",
              currentUserName: userData.fullName(),
              ReportMenuType: 1,
              ReportType: this.props.mode === "DepartmentSend" ? 0 : 1,
              currentDivisionKeygen: divisionKeygen,
              currentDivisionName: userData.selectedDepartmentRole().text,
            };

            url = url + "?" + new URLSearchParams(params).toString();
            console.log("@params-2", params);
            this.$emit("handleSubmit", url);
          }

          // const params = {
          //   dateStart: this.search[0].value,
          //   dateEnd: this.search[1].value,
          //   receiveCodeStart: this.search[2].value,
          //   receiveCodeEnd: this.search[3].value,
          //   divisionType: this.depType !== null ? this.depType.value : null,
          //   divisionKeygen:
          //     this.department !== null ? this.department.value : "",
          //   currentUserName: userData.fullName(),
          //   ReportMenuType: 1,
          //   ReportType: this.props.mode === "DepartmentSend" ? 0 : 1,
          //   currentDivisionKeygen: divisionKeygen,
          //   // currentDivisionName: userData.departmentName(),
          //   currentDivisionName: userData.selectedDepartmentRole().text,
          // };

          // url = url + "?" + new URLSearchParams(params).toString();
          // console.log("@params-2", params);
          // this.$emit("handleSubmit", url);
        }
        // เจ้าหน้าที่ศูนย์รับเรื่องราวร้องทุกข์
        else {
          departmentStore.getById(divisionKeygen).then((response) => {
            const params = {
              dateStart: this.search[0].value,
              dateEnd: this.search[1].value,
              receiveCodeStart: this.search[2].value,
              receiveCodeEnd: this.search[3].value,
              divisionType: this.depType !== null ? this.depType.value : null,
              divisionKeygen:
                this.department !== null ? this.department.value : "",
              currentUserName: userData.fullName(),
              ReportMenuType: 1,
              ReportType: this.props.mode === "DepartmentSend" ? 0 : 1,
              currentDivisionKeygen: divisionKeygen,
              currentDivisionName: response.data.data.name,
            };

            url = url + "?" + new URLSearchParams(params).toString();
            console.log("@params-3", params);
            this.$emit("handleSubmit", url);
          });
        }
      }
      // รายงานรับ|รายงานส่ง ของคัดกรอง
      else if (
        this.props.mode === "ScreeningSend" ||
        this.props.mode === "ScreeningReceived"
      ) {
        const deptScreening = userData.departmentId();
        departmentStore.getById(deptScreening).then((response) => {
          const params = {
            dateStart: this.search[0].value,
            dateEnd: this.search[1].value,
            receiveCodeStart: this.search[2].value,
            receiveCodeEnd: this.search[3].value,
            divisionType: this.depType !== null ? this.depType.value : null,
            divisionKeygen:
              this.department !== null ? this.department.value : "",
            currentUserName: userData.fullName(),
            ReportMenuType: 0,
            ReportType: this.props.mode === "ScreeningSend" ? 0 : 1,
            currentDivisionKeygen: deptScreening,
            currentDivisionName: response.data.data.name,
          };

          url = url + "?" + new URLSearchParams(params).toString();
          console.log("@params-4", params);
          this.$emit("handleSubmit", url);
        });
      }
      // รายงานรับและรายงานส่ง ของรายบุคคล
      else if (this.props.mode === "Personal") {
        // ผู้ดูแลระบบ
        if (userData.selectedRole() == appsettings.complaintRoleId.admin) {
          let divisionKeygen = "";
          divisionKeygen = userData.departmentId();
          let divisionName = "";

          const divistionFilter = _this.departmentForAdmin.find((value) => {
            return value.value == divisionKeygen;
          });

          console.log(
            "divistionFilter",
            divistionFilter,
            _this.departmentForAdmin
          );

          if (divistionFilter !== undefined) {
            divisionName = divistionFilter.text;
          } else {
            divisionName = userData.departmentName();
          }

          const params = {
            dateStart: this.search[0].value,
            dateEnd: this.search[1].value,
            receiveCodeStart: this.search[2].value,
            receiveCodeEnd: this.search[3].value,
            //divisionType: this.depType !== null ? this.depType.value : null,
            //divisionKeygen: divisionKeygen,
            currentUserName: userData.fullName(),
            //ReportMenuType: this.props.mode === "ScreeningSend" ? 0 : 1,
            ReportType: 3,
            currentDivisionKeygen: divisionKeygen,
            currentUserId: this.officer !== null ? this.officer.value : "",
            currentDivisionName: divisionName,
          };

          url = url + "?" + new URLSearchParams(params).toString();
          console.log("@params-5", params);
          this.$emit("handleSubmit", url);
        }
        // อื่น ๆ
        else {
          // เช็คว่าเป็น admin หรือไม่
          // เนื่องจากกรณีที่เป็น admin ชื่อหน่วยงานที่แสดงบน header ของรายงาน ไม่ตรงกับ dropdown กองที่เลือก
          if (userData.isAdminRole()) {
            const selectedDropdown = userData.selectedAdminDepartment();
            if (
              selectedDropdown !== undefined &&
              selectedDropdown !== null &&
              selectedDropdown !== ""
            ) {
              departmentStore.getById(selectedDropdown).then((response) => {
                console.log("@params-response-6", response);
                const params = {
                  dateStart: this.search[0].value,
                  dateEnd: this.search[1].value,
                  receiveCodeStart: this.search[2].value,
                  receiveCodeEnd: this.search[3].value,
                  currentUserName: userData.fullName(),
                  ReportType: 3,
                  currentDivisionKeygen: userData.departmentId(),
                  currentUserId:
                    this.officer !== null ? this.officer.value : "",
                  currentDivisionName: response.data.data.name,
                };

                url = url + "?" + new URLSearchParams(params).toString();
                console.log("@params-6", params);
                this.$emit("handleSubmit", url);
              });
            }
          } else {
            const params = {
              dateStart: this.search[0].value,
              dateEnd: this.search[1].value,
              receiveCodeStart: this.search[2].value,
              receiveCodeEnd: this.search[3].value,
              currentUserName: userData.fullName(),
              ReportType: 3,
              currentDivisionKeygen: userData.departmentId(),
              currentUserId: this.officer !== null ? this.officer.value : "",
              currentDivisionName: userData.selectedDepartmentRole().text,
            };

            url = url + "?" + new URLSearchParams(params).toString();
            console.log("@params-6", params);
            this.$emit("handleSubmit", url);
          }

          // const params = {
          //   dateStart: this.search[0].value,
          //   dateEnd: this.search[1].value,
          //   receiveCodeStart: this.search[2].value,
          //   receiveCodeEnd: this.search[3].value,
          //   //divisionType: this.depType !== null ? this.depType.value : null,
          //   // divisionKeygen:
          //   //   this.department !== null ? this.department.value : "",
          //   currentUserName: userData.fullName(),
          //   //ReportMenuType: this.props.mode === "ScreeningSend" ? 0 : 1,
          //   ReportType: 3,
          //   currentDivisionKeygen: userData.departmentId(),
          //   currentUserId: this.officer !== null ? this.officer.value : "",
          //   // currentDivisionName: userData.departmentName(),
          //   currentDivisionName: userData.selectedDepartmentRole().text,
          // };

          // url = url + "?" + new URLSearchParams(params).toString();
          // console.log("@params-6", params);
          // this.$emit("handleSubmit", url);
        }
      }

      console.log("report url=", url);
    },
    getDepartment(mode) {
      const _this = this;
      let depTypeParam = null;

      console.log("mode", mode);

      if (mode === 0) {
        depTypeParam = _this.depType !== "0" ? _this.depType.value : null;
      } else {
        depTypeParam =
          _this.depTypeFrom !== "0" ? _this.depTypeFrom.value : null;
      }

      storeMaster
        .getReportDepartment(depTypeParam)
        .then(function(response) {
          if (mode === 0) {
            _this.departments = response.data.data;
            _this.department = null;
          } else {
            _this.departmentsFrom = response.data.data;
            _this.departmentFrom = null;
          }

          console.log("@params-dept", _this.departments);
          console.log("@params-deptfrom", _this.departmentFrom);
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getOfficer() {
      const _this = this;
      // console.log(
      //   "@getOfficer userData.departmentIdDefault()",
      //   userData.departmentIdDefault()
      // );
      // console.log(
      //   "@getOfficer userData.selectedAdminDepartment()",
      //   userData.selectedAdminDepartment()
      // );
      // console.log(
      //   "@getOfficer userData.selectedDepartmentRole()",
      //   userData.selectedDepartmentRole()
      // );
      const params = {
        departmentId: userData.selectedAdminDepartment(),
      };
      apiDepartmentRole
        .searchUser(params)
        .then(function(response) {
          console.log("@getOfficer response", response);
          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.userId;
            setData.text = `${o.titleStr} ${o.fName} ${o.lName}`;

            setDataList.push(setData);
          });

          const officerUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          //_this.officers.push(...setDataList);
          _this.officers = officerUnique;
          console.log("@getOfficer length", _this.officers.length);
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
      // if (userData.isAdminRole()) {
      //   console.log("@If", userData.isAdminRole());
      //   storeMaster
      //     .getOfficerInfoAll()
      //     .then(function(response) {
      //       var setDataList = [];

      //       response.data.data.forEach((o) => {
      //         var setData = {};
      //         setData.value = o.user_id;
      //         setData.text = o.title_name + " " + o.fname + " " + o.lname;

      //         setDataList.push(setData);
      //       });

      //       const officerUnique = [
      //         ...new Map(
      //           setDataList.map((item) => [item["value"], item])
      //         ).values(),
      //       ];

      //       //_this.officers.push(...setDataList);
      //       _this.officers = officerUnique;

      //       _this.$forceUpdate();
      //     })
      //     .catch(function(error) {
      //       // handle error
      //       console.log("error", error);
      //     });
      // } else {
      //   console.log("@Else", userData.departmentId());
      //   storeMaster
      //     .getOfficerInfos(userData.departmentId())
      //     .then(function(response) {
      //       var setDataList = [];

      //       response.data.data.forEach((o) => {
      //         var setData = {};
      //         setData.value = o.user_id;
      //         setData.text = o.title_name + " " + o.fname + " " + o.lname;

      //         setDataList.push(setData);
      //       });

      //       const officerUnique = [
      //         ...new Map(
      //           setDataList.map((item) => [item["value"], item])
      //         ).values(),
      //       ];

      //       //_this.officers.push(...setDataList);
      //       _this.officers = officerUnique;

      //       _this.$forceUpdate();
      //     })
      //     .catch(function(error) {
      //       // handle error
      //       console.log("error", error);
      //     });
      // }
    },
    getDepartmentNameForAdmin() {
      const _this = this;

      storeMaster
        .getDepartment(2)
        .then(function(response) {
          // handle success
          console.log("@params-deptAdmin", response);

          _this.departmentForAdmin = response.data.data;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    selectDepTypeOnInput(mode = 0) {
      this.getDepartment(mode);
      this.$forceUpdate();
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
